var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isVisibilityModal)?_c('div',{staticClass:"mobile__footer_block_button",on:{"click":_vm.modalAction}},[_c('p',{staticClass:"mobile__footer_block_button_p"},[_vm._v(_vm._s(_vm.button))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }